import { render } from "./Formats.vue?vue&type=template&id=0897074d&scoped=true"
import script from "./Formats.vue?vue&type=script&lang=js"
export * from "./Formats.vue?vue&type=script&lang=js"

import "./Formats.vue?vue&type=style&index=0&id=0897074d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0897074d"]])

export default __exports__